module.exports = __webpack_public_path__ + "assets/img/sakura02@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top/sakura02@2x.png
// module id = Lo9t
// module chunks = 1